import { render, staticRenderFns } from "./Dashboard2.vue?vue&type=template&id=21e1cc2d&scoped=true&"
import script from "./Dashboard2.vue?vue&type=script&lang=js&"
export * from "./Dashboard2.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard2.vue?vue&type=style&index=0&id=21e1cc2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e1cc2d",
  null
  
)

export default component.exports